import { useMemo } from 'react';

const { NETWORK_NAME_LABELS, PAYMENT_STATES_LABELS } = require('src/utils/constants');
const { dateToFormattedStr } = require('src/utils/dates');
const { removeTrailingZeros } = require('src/utils/strings');

const MobilePaymentsTable = ({ transactions }) => {
    const paymentsGroupedByDate = useMemo(() => {
        return transactions.reduce((acc, payment) => {
            const createdAt = dateToFormattedStr(new Date(payment.createdAt));
            if (createdAt in acc) {
                return { ...acc, [createdAt]: [...acc[createdAt], payment] };
            }
            return { ...acc, [createdAt]: [payment] };
        }, {});
    }, [transactions]);

    return Object.keys(paymentsGroupedByDate).map((date, i) => (
        <div key={i} className={`mb-6 ${i === 0 && 'mt-12'}`}>
            <p className="text-center text-base">{date}</p>
            {paymentsGroupedByDate[date].map((payment, j) => (
                <div key={j} className="flex justify-between items-center border-b border-gray-light pb-4 mt-6">
                    <div className="flex flex-col justify-between">
                        <span>{payment.productNames.join(', ')}</span>
                        <div className="flex flex-col items-start justify-center">
                            <span className="text-xs">{payment.customerEmail}</span>
                            <span className="text-gray-darker text-xs">
                                {payment.customerFirstName} {payment.customerLastName}
                            </span>
                        </div>
                    </div>
                    <div className="flex flex-col justify-between">
                        <span className="text-right">${payment.costInUSD}</span>
                        <span className="text-right text-xs">
                            {removeTrailingZeros(parseFloat(payment.tokenAmount).toFixed(8))}&nbsp;
                            {payment.coin}
                        </span>
                        <span className="text-right text-xs text-gray-darker">
                            {NETWORK_NAME_LABELS[payment.network]} network
                        </span>
                        <span className="text-right text-xs text-gray-darker">
                            {PAYMENT_STATES_LABELS[payment.status]}
                        </span>
                    </div>
                </div>
            ))}
        </div>
    ));
};

export default MobilePaymentsTable;
